import { render, staticRenderFns } from "./IncomingChat.vue?vue&type=template&id=9b8d8abc&scoped=true&"
import script from "./IncomingChat.vue?vue&type=script&lang=js&"
export * from "./IncomingChat.vue?vue&type=script&lang=js&"
import style0 from "./IncomingChat.vue?vue&type=style&index=0&id=9b8d8abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8d8abc",
  null
  
)

export default component.exports